import { BASE_URL } from "../store/config";
import instance from "./http";

const getUserInfo = (callback) => {
    instance.get(BASE_URL + 'users/current').then((res) => {
        const userData = res.data.data;
        if (callback) callback(userData);
    })
}
const updateUserInfo = (params, callback) => {
    instance.put(BASE_URL + "users/current", params).then((res) => {
        if (callback) callback(res);
    })
}

export default {
    getUserInfo,
    updateUserInfo
}